module.exports = __webpack_public_path__ + "media/honey-icons/icon-forward-7c150524.svg";